import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { GoogleMapsState, StoreError } from '@/store/modules/google-maps/types'

export const actions: ActionTree<GoogleMapsState, RootState> = {
  async setGroundOverlays ({ commit }, groundOverlays) {
    try {
      return commit('SET_GROUND_OVERLAYS', groundOverlays)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setOverlayViews ({ commit }, overlays) {
    try {
      return commit('SET_OVERLAY_VIEWS', overlays)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setPosition ({ commit }, position) {
    try {
      console.log({ ...position })
      return commit('SET_POSITION', position)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setMarkers ({ commit }, markers) {
    try {
      return commit('SET_MARKERS', markers)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setInfoViewStatus ({ commit }, active) {
    try {
      return commit('SET_INFOVIEW_STATUS', active)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setInfoViewData ({ commit }, infoview) {
    try {
      return commit('SET_INFOVIEW_DATA', infoview)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async resetInfoView ({ commit }) {
    try {
      const infoview = {
        status: {
          active: false,
          selectedMarker: ''
        },
        title: '',
        subtitle: '',
        chartOptions: {
          series: []
        },
        data: [],
        date: ''
      }
      return commit('RESET_INFOVIEW', infoview)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setAutocomplete ({ commit }, autocomplete) {
    try {
      return commit('SET_AUTOCOMPLETE', autocomplete)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setOpenDefaultMarkerOption ({ commit }, openDefaultMarkerOption) {
    try {
      return commit('SET_OPEN_DEFAULT_MARKER_OPTION', openDefaultMarkerOption)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async setDefaultMarker ({ commit }, defaultMarker) {
    try {
      return commit('SET_DEFAULT_MARKER', defaultMarker)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
